import React from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

const ReloadPrompt = () => {
  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(r) {
      if (r) {
        console.log('Service Worker registered:', r.scope);
      }
    },
    onRegisterError(error) {
      console.error('Service Worker registration error:', error);
    },
  });

  const close = () => {
    setOfflineReady(false);
    setNeedRefresh(false);
  };

  if (!offlineReady && !needRefresh) {
    return null;
  }

  return (
    <div className="reload-prompt">
      <div className="reload-prompt-toast">
        <p className="reload-prompt-message">
          {offlineReady
            ? 'La aplicación está lista para usarse sin conexión.'
            : 'Hay una nueva versión disponible.'}
        </p>
        <div className="reload-prompt-actions">
          {needRefresh && (
            <button
              className="reload-prompt-button"
              onClick={() => updateServiceWorker(true)}
            >
              Recargar
            </button>
          )}
          <button className="reload-prompt-button" onClick={close}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReloadPrompt;
